import { useStore } from '~/store/store-context';
export function getTemplateType(templateContent, introductoryMessages) {
    if (!introductoryMessages) {
        return "custom";
    }
    switch(templateContent){
        case introductoryMessages.proposal:
            return "proposal";
        case introductoryMessages.invitation:
            return "invitation";
        default:
            return "custom";
    }
}
export function useEditIntroMessage() {
    var _ref, _ref1;
    const introductoryMessages = useStore((state)=>{
        var _state_userInfo_businessSettings, _state_userInfo;
        return (_state_userInfo = state.userInfo) === null || _state_userInfo === void 0 ? void 0 : (_state_userInfo_businessSettings = _state_userInfo.businessSettings()) === null || _state_userInfo_businessSettings === void 0 ? void 0 : _state_userInfo_businessSettings.introductoryMessages;
    });
    const templateTypeToContent = {
        ["proposal"]: (_ref = introductoryMessages === null || introductoryMessages === void 0 ? void 0 : introductoryMessages.proposal) !== null && _ref !== void 0 ? _ref : '',
        ["invitation"]: (_ref1 = introductoryMessages === null || introductoryMessages === void 0 ? void 0 : introductoryMessages.invitation) !== null && _ref1 !== void 0 ? _ref1 : '',
        ["custom"]: ''
    };
    return {
        templateTypeToContent,
        getTemplateTypeByMessage: (templateContent)=>getTemplateType(templateContent, introductoryMessages)
    };
}
export var TemplateType = /*#__PURE__*/ function(TemplateType) {
    TemplateType["Proposal"] = "proposal";
    TemplateType["Invitation"] = "invitation";
    TemplateType["Custom"] = "custom";
    return TemplateType;
}({});
export const templateTypeToDropdownLabel = {
    ["proposal"]: 'New client onboarding template',
    ["invitation"]: 'Existing client onboarding template',
    ["custom"]: 'Custom message'
};
export const orderedTemplateTypesForDropdown = [
    "proposal",
    "invitation",
    "custom"
];
export const isCustomMessageType = (templateType)=>templateType === "custom";
